import angular from "angular";
import AdminStudentDrivesController from "./admin-student-drives.controller";
import template from "./admin-student-drives.html";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.students.view.drives", {
    url: "/drives",
    controller: AdminStudentDrivesController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
        USER_ROLES.staff,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.students.drives", [])
  .config(config)
  .controller("AdminStudentDrivesController", AdminStudentDrivesController);
